import "./Home.css";
import HomeBanner from "./Home/HomeBanner";
import HowItWorks from "./Home/HowItWorks";
import Solutions from "./Home/Solutions";
import FeaturedBrand from "./Home/FeaturedBrand";
import StrategicPartner from "./Home/StrategicPartner";
import WhyChooseUs from "./Home/WhyChooseUs";
import RecentWork from "./Home/RecentWork";
import Testimonials from "./Home/Testimonials";
import ContactSection from "./Home/ContactSection";
import wattleImg from "../assets/figma_wattle_why.svg";

export default function Home() {
  return (
    <div className="home">
      <HomeBanner />
      <HowItWorks />
      <Solutions />
      <FeaturedBrand />
      <StrategicPartner />
      <div className="grey-band">
        <img src={wattleImg} alt="" className="grey-band-wattle" aria-hidden="true" />
        <WhyChooseUs />
        <RecentWork />
      </div>
      <Testimonials />
      <ContactSection />
    </div>
  );
}
